import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { merge } from 'lodash';

import { isMobile } from 'lib/responsive';
import { ButtonV2, CircleIcon } from '@zola/zola-ui';
import { Celebratory1 } from '@zola/zola-ui/src/assets/images/icons';

import css from 'stylesheets/pages/PublishWebsiteModal.module.less';
import { hideModal } from '../../../actions/ModalActions';

const PublishWebsiteModal = props => {
  const { wedding, isRegistryPublic, isRegistryVisible, closeModal } = props;
  const { slug } = wedding;
  const modalText = `Your website is visible! Guests can now see your site${
    isRegistryPublic && isRegistryVisible ? ' and registry.' : '.'
  }`;
  const fullWidth = isMobile();

  return (
    <div id="publish-website-modalv2">
      <div className={css.container}>
        <CircleIcon image={Celebratory1} variant="cream" size={100} className={css.circleIcon} />
        <h3 className={css.body}>{modalText}</h3>
        <div className={css.buttonContainer}>
          <ButtonV2
            href={`/wedding/${slug}`}
            onClick={closeModal}
            target="_blank"
            component="a"
            role="link"
            fullWidth={fullWidth}
          >
            Visit&nbsp;<span className="hidden-sm hidden-xs">Your&nbsp;</span>Website
          </ButtonV2>
        </div>
      </div>
    </div>
  );
};

PublishWebsiteModal.propTypes = {
  wedding: PropTypes.shape({ slug: PropTypes.string }),
  isRegistryPublic: PropTypes.bool,
  isRegistryVisible: PropTypes.bool,
  closeModal: PropTypes.func.isRequired,
};

const pageCheck = page => page.type === 'REGISTRY' && page.hidden === false;

const mapStateToProps = state => {
  const pagesById = state.website.pages.byId;
  const pageIds = Object.keys(pagesById);
  const isRegistryVisible = pageIds.some(id => pageCheck(pagesById[id]));
  return {
    wedding: merge({}, state.publicWebsite.wedding, state.wedding.wedding),
    isRegistryPublic: state.registry.is_public,
    isRegistryVisible,
  };
};

const mapDispatchToProps = dispatch => ({
  closeModal: () => dispatch(hideModal()),
});

export default connect(mapStateToProps, mapDispatchToProps)(PublishWebsiteModal);



// WEBPACK FOOTER //
// ./src/components/manage/website/PublishWebsiteModalv2.jsx